export default "__VITE_ASSET__7fWSUDeO__"